export interface CustomTagManagerData {
  resources: TagResource[];
}

export interface TagResource {
  url: string;
  env: string[];
}
